import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Toast styles
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import ButtonLoader from "../../../../components/ButtonLoader/index.js";
import CustomerSearchSelectAsync from "../../../../components/CustomerSearchSelectAsync";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./style.css";
import OrderUserAssignment from "./orders-single/order-components/orderUserAssignment/OrderUserAssignment"; // adjust import path as needed
import { Avatar } from "@mui/material";
import PurchaseOrderList from "../../../../components/PurchaseOrder/PurchaseOrderList";
import { AuthContext } from "../../../../helpers/AuthContext";
import CircularProgress from "@mui/material/CircularProgress";
// Material UI and Formik imports for the Create Project popup
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Tooltip,
  FormControlLabel,
  Divider,
  FormHelperText,
  Stack,
  Chip,
  InputAdornment,
  Skeleton,
  Alert,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Snackbar,
  Checkbox,
  Menu,
  ListItemIcon,
  ListItemText,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ClearIcon from "@mui/icons-material/Clear";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";

import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import autoTable from "jspdf-autotable";

import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getNextProjectNumber } from "../../../../services/projectNumbers";
import { createCustomerContact, getClientContacts } from "../../../../services/customer";
import CustomerContactDialog from "../../../../components/CustomerContactDialog";
import useWorkflowDisplaySettings from "../../../../hooks/useWorkflowDisplaySettings";
import {
  fetchClientContactOptions,
  getCustomerBusinessName,
  getCustomerChangeValues,
  normalizeCreatedClientContact,
  withOptionalClientContact,
} from "./clientContactSelection";
import { createProjectValidationSchema } from "./createProjectValidation";
import ProjectCustomerEmailNotice from "./ProjectCustomerEmailNotice";
import {
  UIStatusChip,
  UITableActionCell,
  UITableShell,
  UITableToolbar,
} from "../../../../components/ui";
import PipelineBoard from "../pipeline/components/PipelineBoard";
import { buildProjectReportExportFilters, fetchAllProjectExportRows, sortProjectExportRows } from "./projectReportExport";

import { Formik, Form, Field, ErrorMessage } from "formik";

// Centralized event types (used by the Create Project modal)
export const EVENT_TYPES = [
  "Advertising",
  "Awards",
  "Camp clothing",
  "Celebration",
  "Client appreciation",
  "Company branding",
  "Company offsite",
  "Conference",
  "Design",
  "Donor gift",
  "Employee appreciation",
  "Evenet promotion", // (original spelling kept—see note below)
  "Fundraiser",
  "Gift with purchase",
  "Golf tournament",
  "Holiday event",
  "Indvidiaul", // (original spelling kept—see note below)
  "Internal use",
  "Mail out",
  "On-premise",
  "Online store",
  "Other PPE",
  "Product launch",
  "Program",
  "Public relations",
  "Recruitment",
  "Retail merchandise",
  "Sales tool",
  "Samples",
  "School clothing",
  "School orientation",
  "Season celebration",
  "Spirit wear",
  "Sporting event",
  "Team building",
  "Thank-you gift",
  "Trade show",
  "Travel",
  "Uniforms",
  "Virtual",
  "Wedding",
  "Wellness program",
];

const LEGACY_SO_DISPLAY_MAP = {
  presentation: "Presentation Draft",
  "sent for agreement": "Agreement Pending",
  rejected: "Client Change Requested",
  "changes requested": "Client Change Requested",
  completed: "Client Approved",
  "sales order ready": "Client Approved",
  "customer signed": "Client Approved",
  "ready to be invoiced": "Ready to be Invoiced",
};

const canonicalizeSoDisplay = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return raw;
  const mapped = LEGACY_SO_DISPLAY_MAP[raw.toLowerCase()];
  return mapped || raw;
};

const STATUS_FILTER_OPTIONS = {
  SO: [
    "Quote Requested",
    "Waiting",
    "Presentation Draft",
    "Presentation Sent",
    "Estimate Draft",
    "Estimate Sent",
    "Agreement Pending",
    "Agreement Sent",
    "Client Change Requested",
    "Client Approved",
    "In Production",
    "Shipped",
    "Ready to be Invoiced",
    "Invoiced",
    "Closed",
  ],
  PO: [
    "Created",
    "Open",
    "Follow Up",
    "Submitted",
    "Confirmed",
    "Shipped",
    "Partially Received",
    "Received",
    "Production Scheduled",
    "In Progress",
    "Production Complete",
    "Ready For Billing",
    "Billed",
    "Closed",
  ],
};

const ALL_COLUMNS = [
  {
    id: "s_no",
    field: null,
    label: "#",
    sortable: false,
    minWidth: 55,
    align: "center",
    visible: true,
  },
  {
    id: "project_number",
    field: "OrderId",
    label: "Project #",
    sortable: true,
    minWidth: 130,
    align: "left",
    visible: true,
  },
  {
    id: "customer_name",
    field: "customer",
    label: "Customer",
    sortable: false,
    minWidth: 180,
    align: "left",
    visible: true,
  },
  {
    id: "project_name",
    field: "ProjectName",
    label: "Project Name",
    sortable: true,
    minWidth: 200,
    align: "left",
    visible: true,
  },
  {
    id: "event_type",
    field: null,
    label: "Event Type",
    sortable: false,
    minWidth: 140,
    align: "left",
    visible: false,
  },
  {
    id: "so_status",
    field: "OrderStatus",
    label: "SO Status",
    sortable: true,
    minWidth: 160,
    align: "left",
    visible: true,
  },
  {
    id: "po_status",
    field: "OrderStatus",
    label: "PO Status",
    sortable: false,
    minWidth: 140,
    align: "left",
    visible: true,
  },
  {
    id: "date_created",
    field: null,
    label: "Created",
    sortable: true,
    minWidth: 110,
    align: "center",
    visible: false,
  },
  {
    id: "assigned_to",
    field: "AssignedTo",
    label: "Assigned",
    sortable: false,
    minWidth: 130,
    align: "left",
    visible: true,
  },
  {
    id: "actions",
    field: "action",
    label: "Actions",
    sortable: false,
    minWidth: 100,
    align: "center",
    visible: true,
    locked: true,
  },
];

const EXPORT_COLS = Object.freeze([
  { id: "project_number", label: "Project #" },
  { id: "customer_name", label: "Customer" },
  { id: "customer_email", label: "Email" },
  { id: "project_name", label: "Project Name" },
  { id: "event_type", label: "Event Type" },
  { id: "in_hands_date", label: "In-Hands Date" },
  { id: "so_status", label: "SO Status" },
  { id: "po_status", label: "PO Status" },
  { id: "date_created", label: "Created" },
  { id: "assigned_to", label: "Assigned" },
]);

const getExportVal = (o, id) => {
  switch (id) {
    case "project_number":
      return o.OrderId ?? "";
    case "customer_name":
      return o.CustomerName || "";
    case "customer_email":
      return o.Email || "";
    case "project_name":
      return o.ProjectName ?? "";
    case "event_type":
      return o.EventType ?? "";
    case "in_hands_date":
      return o.inHandsDate
        ? new Date(o.inHandsDate).toLocaleDateString("en-CA", {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        : "";
    case "so_status":
      return canonicalizeSoDisplay(o.OrderStatus?.SO || "");
    case "po_status":
      return o.OrderStatus?.PO || "";
    case "date_created":
      return o.createdAt
        ? new Date(o.createdAt).toLocaleDateString("en-CA", {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        : "";
    case "assigned_to":
      return Array.isArray(o.AssignedTo)
        ? o.AssignedTo.map((u) => {
            const first = String(u.first_name || u.firstName || "").trim();
            const last = String(u.last_name || u.lastName || "").trim();
            const full = [first, last].filter(Boolean).join(" ");
            return full || u.name || u.fullName || (u.id != null ? `User #${u.id}` : "Unassigned");
          }).filter(Boolean).join(", ")
        : "";
    default:
      return "";
  }
};

const SO_STATUS_TONES = {
  "Quote Requested": "neutral",
  Waiting: "neutral",
  "Presentation Draft": "info",
  "Presentation Sent": "info",
  "Estimate Draft": "accent",
  "Estimate Sent": "accent",
  "Agreement Pending": "accent",
  "Agreement Sent": "accent",
  "Client Change Requested": "warning",
  "Client Approved": "success",
  "In Production": "accent",
  Shipped: "info",
  "Ready to be Invoiced": "warning",
  Invoiced: "success",
  Closed: "neutral",
};

const PO_STATUS_TONES = {
  Created: "info",
  Submitted: "info",
  Confirmed: "success",
  "Production Scheduled": "accent",
  "Production Complete": "accent",
  "Follow Up": "warning",
  Open: "info",
  Shipped: "accent",
  Received: "success",
  "Partially Received": "warning",
  "Ready For Billing": "warning",
  Closed: "neutral",
  Billed: "success",
};

const getSOStatusTone = (status) => SO_STATUS_TONES[status] || "neutral";
const getPOStatusTone = (status) => PO_STATUS_TONES[status] || "neutral";

const formatInHandsDate = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;
  return d.toLocaleDateString("en-CA", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// ==============================
// InstanceOrders Page Component
// ==============================

const AssignedUsersColumn = ({ assigned, allUsers }) => {
  // Merge each assigned user with full details from allUsers
  const mergedUsers = assigned.map((u) => {
    const fullUser = allUsers.find((user) => user.id === u.id);
    return fullUser ? { ...u, ...fullUser } : u;
  });

  // Show up to 2 avatars
  const avatarsToShow = mergedUsers.slice(0, 2);

  // Helper function to extract the avatar URL (using robust parsing)
  const getUserAvatarUrl = (user) => {
    if (!user || !user.profilePicture) return null;

    let profilePic = user.profilePicture;

    // If profilePicture is already an array, process it directly
    if (Array.isArray(profilePic)) {
      const selectedPic =
        profilePic.find((pic) => pic.selected) || profilePic[0];
      if (selectedPic && typeof selectedPic.url === "string") {
        return selectedPic.url.startsWith("uploads")
          ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${selectedPic.url}`
          : selectedPic.url;
      }
    }

    // If profilePicture is a string, try parsing it as JSON
    if (typeof profilePic === "string") {
      try {
        const parsed = JSON.parse(profilePic);
        if (Array.isArray(parsed) && parsed.length > 0) {
          const selectedPic = parsed.find((pic) => pic.selected) || parsed[0];
          if (selectedPic && typeof selectedPic.url === "string") {
            return selectedPic.url.startsWith("uploads")
              ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${selectedPic.url}`
              : selectedPic.url;
          }
        }
      } catch (e) {
        // If parsing fails, assume profilePic is a plain URL.
        return profilePic.startsWith("uploads")
          ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${profilePic}`
          : profilePic;
      }
    }
    return null;
  };

  return (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
      {avatarsToShow.map((user) => {
        const avatarUrl = getUserAvatarUrl(user);
        // If no avatar URL, fallback to initials
        const initials =
          !avatarUrl && user.first_name
            ? user.first_name.charAt(0).toUpperCase()
            : "";
        return (
          <Avatar
            key={user.id}
            src={avatarUrl || undefined}
            sx={{ width: 30, height: 30, mr: 0.5 }}
          >
            {(!avatarUrl && initials) || "?"}
          </Avatar>
        );
      })}
      {mergedUsers.length > 2 && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            background: "var(--ec-status-error-bg)",
            borderRadius: "50%",
            padding: "2px 6px",
            fontSize: "12px",
            fontWeight: "700",
            lineHeight: 1,
            color: "var(--ec-status-error-text)",
          }}
        >
          +{mergedUsers.length - 2}
        </Box>
      )}
    </Box>
  );
};

function InstanceOrders() {
  const [orders, setOrders] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [customerList, setCustomerList] = useState([]); // All customers for the create order select box
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isOrderPopupOpen, setIsOrderPopupOpen] = useState(false);
  // We now use a separate state for the input and for triggering search
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // State for controlling Create Order modal
  const [orderModalOpen, setOrderModalOpen] = useState(false);

  let { instanceUniqueId } = useParams();
  const {
    getWorkflowLabel,
    getWorkflowTooltip,
    loading: workflowSettingsLoading,
  } = useWorkflowDisplaySettings(instanceUniqueId);
  let history = useHistory();
  const location = useLocation();
  const [allUsers, setAllUsers] = useState([]);
  const projectViewMode = new URLSearchParams(location.search).get("view") === "kanban" ? "kanban" : "table";
  const [kanbanRefreshKey, setKanbanRefreshKey] = useState(0);
  const pipelineQuery = new URLSearchParams(location.search).get("orderSearchQuery") ?? new URLSearchParams(location.search).get("q") ?? "";

  const { authState } = useContext(AuthContext);
  const [orderTab, setOrderTab] = useState("myOrders");
  const [repProjectViewability, setRepProjectViewability] = useState("scoped");
  const [soStatusFilter, setSoStatusFilter] = useState("");
  const [poStatusFilter, setPoStatusFilter] = useState("");
  const role = String(authState.role || "").trim().toLowerCase();
  const isRepRole = role === "client-rep" || role === "order-rep";
  const repCanViewAllProjects = isRepRole && repProjectViewability === "all";
  const canSeeAllProjectsTab =
    ["administrator", "super-administrator"].includes(role) ||
    role === "finance-rep" ||
    repCanViewAllProjects;
  const canUseAllOrdersFilters =
    ["administrator", "super-administrator"].includes(role) || role === "finance-rep";
  const OrderSourceTabs = [
    {
      key: "myOrders",
      label: "My Projects",
      tooltip: "Projects assigned to me",
    },
    ...(canSeeAllProjectsTab
      ? [{ key: "allOrders", label: "All Projects", tooltip: "All projects" }]
      : []),
  ];

  const pageRef = useRef({ suppressNextOnPageChange: false });

  const navigateWithGuard = (searchParams, { replace = false } = {}) => {
    pageRef.current.suppressNextOnPageChange = true;
    const method = replace ? "replace" : "push";
    history[method]({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const setProjectViewMode = (nextView) => {
    if (!nextView || nextView === projectViewMode) return;
    const params = new URLSearchParams(location.search);
    if (nextView === "kanban") params.set("view", "kanban");
    else params.delete("view");
    navigateWithGuard(params);
  };

  // On first load, make sure we have canonical params and ignore the first page event.
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    if (!p.get("page") || !p.get("tab")) {
      pageRef.current.suppressNextOnPageChange = true; // block the phantom onPageChange
      p.set("page", "1");
      p.set("tab", "myOrders");
      navigateWithGuard(p, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  const handleSearch = useCallback(
    async (page = 1, query, tab, customerId, soStatus, poStatus) => {
      // Only allow nullish fallback; no logical OR mixed in
      const resolvedCustomerId = customerId ?? undefined;

      setLoading(true);
      try {
        // const rpp = 12;
        const rpp = rowsPerPage;
        const params = {
          orderSearchQuery: query,
          page,
          rpp,
          tab,
          instanceUniqueId,
          ...(tab === "myOrders" ? { assignedTo: authState?.id } : {}),
          ...(resolvedCustomerId ? { customerId: resolvedCustomerId } : {}),
          ...(tab === "allOrders" && soStatus ? { soStatus } : {}),
          ...(tab === "allOrders" && poStatus ? { poStatus } : {}),
        };

        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/get-orders`,
          {
            params,
            headers: { accessToken: localStorage.getItem("accessToken") },
          },
        );

        const results = data.Results || [];
        setRepProjectViewability(
          data.RepProjectViewability === "all" ? "all" : "scoped"
        );
        const apiTotalResults = data.TotalResults ?? results.length;
        const apiTotalPages =
          data.TotalPages ?? Math.max(1, Math.ceil(apiTotalResults / rpp));

        if (page > apiTotalPages && apiTotalPages > 0) {
          const p = new URLSearchParams(location.search);
          if (query) p.set("q", query);
          else p.delete("q");
          p.set("page", String(apiTotalPages));
          p.set("tab", tab);
          if (tab === "allOrders") {
            if (soStatus) p.set("soStatus", soStatus);
            else p.delete("soStatus");
            if (poStatus) p.set("poStatus", poStatus);
            else p.delete("poStatus");
          } else {
            p.delete("soStatus");
            p.delete("poStatus");
          }
          navigateWithGuard(p, { replace: true });
          return;
        }

        setOrders(results);
        setCustomerList(Array.isArray(data.Customers) ? data.Customers : []);
        setTotalResults(apiTotalResults);
        setTotalPages(apiTotalPages);
        setCurrentPage(Math.min(page, apiTotalPages));
        setError("");
      } catch (err) {
        setError("An error occurred while fetching orders.");
      } finally {
        setLoading(false);
      }
    },
    // keep this stable but correct; do NOT include orderTab here since we pass tab explicitly
    [authState?.id, instanceUniqueId],
  );

  // 🧭 Normalize URL on first load so we always start at ?tab=myOrders&page=1
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get("orderSearchQuery") ?? params.get("q") ?? "";
    const raw = parseInt(params.get("page") || "1", 10);
    const tab = params.get("tab") || "myOrders";
    const cid = params.get("customerId") || undefined;
    const soStatus = params.get("soStatus") || "";
    const poStatus = params.get("poStatus") || "";

    // 👇 gate: if "myOrders" needs assignedTo, wait until we actually have it
    if (tab === "myOrders" && !authState?.id) return;

    setOrderTab(tab);
    setSearchInput(q);
    setCustomerFilter(cid ?? "");
    setSoStatusFilter(tab === "allOrders" ? soStatus : "");
    setPoStatusFilter(tab === "allOrders" ? poStatus : "");

    if (params.get("view") === "kanban") {
      setLoading(false);
      return;
    }

    handleSearch(Math.max(raw, 1), q, tab, cid, soStatus, poStatus);
  }, [location.search, authState?.id, handleSearch]);

  const [customerFilter, setCustomerFilter] = useState("");

  // Function to fetch orders based on query and pagination.
  // Here we use searchInput (or you could pass a query parameter) only when Search is clicked.

  useEffect(() => {
    async function fetchAllUsers() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`,
        );
        setAllUsers(response.data.listOfUsers || []);
      } catch (error) {
        console.error("Error fetching users", error);
      }
    }
    fetchAllUsers();
  }, [instanceUniqueId]);

  const handleSearchButtonClick = () => {
    const params = new URLSearchParams(location.search);
    if (searchInput) params.set("orderSearchQuery", searchInput);
    else params.delete("orderSearchQuery");
    params.set("page", "1");
    params.set("tab", orderTab);
    if (orderTab === "allOrders") {
      if (soStatusFilter) params.set("soStatus", soStatusFilter);
      else params.delete("soStatus");
      if (poStatusFilter) params.set("poStatus", poStatusFilter);
      else params.delete("poStatus");
    } else {
      params.delete("soStatus");
      params.delete("poStatus");
    }
    navigateWithGuard(params);
  };

  const theme = useTheme();
  const C = {
    paperBg: theme.palette.background.paper,
    subtleBg: theme.palette.action.hover,
    border: theme.palette.divider,
    textPri: theme.palette.text.primary,
    textSec: theme.palette.text.secondary,
    textMuted: theme.palette.text.disabled,
    white: theme.palette.common.white,
    headerBg: theme.eliteCore.tokens.color.neutral[800],
    headerBgHover: theme.eliteCore.tokens.color.neutral[700],
    headerText: theme.eliteCore.tokens.color.neutral[50],
    headerTextMuted: theme.eliteCore.tokens.color.neutral[400],
  };

  // const showSnackbar = (message, severity = "success") =>
  //   setSnackbar({ open: true, message, severity });

  const [density, setDensity] = useState("comfortable");
  

  const [visibleColumns, setVisibleColumns] = useState(
    () =>
      new Set(ALL_COLUMNS.filter((c) => c.visible !== false).map((c) => c.id)),
  );

  const [sortBy, setSortBy] = useState("");
  const [sortDir, setSortDir] = useState("asc");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [densityMenuAnchor, setDensityMenuAnchor] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(12);

  const densitySettings = {
    compact: { py: 0.75, fontSize: "0.8125rem" },
    comfortable: { py: 1.5, fontSize: "0.875rem" },
    spacious: { py: 2.25, fontSize: "0.9375rem" },
  };
  const currentDensity = densitySettings[density];

  const showSnackbar = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const toggleColVisibility = (colId) =>
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      next.has(colId) ? next.delete(colId) : next.add(colId);
      return next;
    });

  const handleSort = (colId) => {
    if (sortBy === colId) {
      if (sortDir === "asc") setSortDir("desc");
      else {
        setSortBy("");
        setSortDir("asc");
      }
    } else {
      setSortBy(colId);
      setSortDir("asc");
    }
  };

  const filteredOrders = orders.filter((order) => {
    if (orderTab === "myOrders") {
      return (
        Array.isArray(order.AssignedTo) &&
        order.AssignedTo.some((u) => u.id === authState.id)
      );
    }
    return true;
  });

  const sortedOrders = useMemo(() => {
    if (!sortBy) return filteredOrders;
    return [...filteredOrders].sort((a, b) => {
      let aVal = "",
        bVal = "";
      if (sortBy === "so_status") {
        aVal = canonicalizeSoDisplay(a.OrderStatus?.SO || "");
        bVal = canonicalizeSoDisplay(b.OrderStatus?.SO || "");
      } else if (sortBy === "project_number") {
        aVal = String(a.OrderId ?? "");
        bVal = String(b.OrderId ?? "");
      } else if (sortBy === "project_name") {
        aVal = String(a.ProjectName ?? "");
        bVal = String(b.ProjectName ?? "");
      } else if (sortBy === "date_created") {
        aVal = String(a.createdAt ?? "");
        bVal = String(b.createdAt ?? "");
      } else {
        aVal = String(a[sortBy] ?? "");
        bVal = String(b[sortBy] ?? "");
      }
      return sortDir === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    });
  }, [filteredOrders, sortBy, sortDir]);

  // const handleSort = (colId) => {
  //   if (sortBy === colId) {
  //     if (sortDir === "asc") setSortDir("desc");
  //     else { setSortBy(""); setSortDir("asc"); }
  //   } else {
  //     setSortBy(colId); setSortDir("asc");
  //   }
  //   setCurrentPage(1);
  // };

  const [exporting, setExporting] = useState(false);

  // Fetch every matching active project before formatting any download. Reuse
  // the server-side scope, status filters and archive exclusion of the list.
  const exportProjects = async (format) => {
    if (exporting || loading) return;
    setExporting(true);
    try {
      const filters = buildProjectReportExportFilters({
        search: location.search,
        instanceUniqueId,
        userId: authState?.id,
      });
      const exportRows = await fetchAllProjectExportRows(
        async (params) => {
          const response = await axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/get-orders`,
            {
              params,
              headers: { accessToken: localStorage.getItem("accessToken") },
            },
          );
          return response.data;
        },
        filters,
      );
      const matchingRows = filters.tab === "myOrders"
        ? exportRows.filter((order) =>
            Array.isArray(order.AssignedTo) &&
            order.AssignedTo.some((u) => String(u.id) === String(authState?.id))
          )
        : exportRows;
      // Match the table's optional sort, applied across ALL pages.
      // Enrich the report's assigned users with the same instance user directory
      // used by the on-screen avatars. Never export role names as people.
      const rows = sortProjectExportRows(matchingRows, sortBy, sortDir, canonicalizeSoDisplay)
        .map((order) => ({
          ...order,
          AssignedTo: Array.isArray(order.AssignedTo)
            ? order.AssignedTo.map((assigned) => {
                const user = allUsers.find((candidate) => String(candidate.id) === String(assigned.id));
                return user ? { ...assigned, ...user } : assigned;
              })
            : [],
        }));
      const filename = `projects_${new Date().toISOString().split("T")[0]}`;

      if (format === "csv") {
        const csv = [
          EXPORT_COLS.map((c) => `"${c.label.replace(/"/g, '""')}"`).join(","),
          ...rows.map((o) => EXPORT_COLS.map((c) =>
            `"${String(getExportVal(o, c.id)).replace(/"/g, '""')}"`
          ).join(",")),
        ].join("\n");
        const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } else if (format === "excel") {
        const content = [
          EXPORT_COLS.map((c) => c.label).join("\t"),
          ...rows.map((o) => EXPORT_COLS.map((c) => getExportVal(o, c.id)).join("\t")),
        ].join("\n");
        const url = URL.createObjectURL(new Blob([content], { type: "application/vnd.ms-excel" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.xls`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } else if (format === "pdf") {
        // A3 landscape provides meaningful space for all ten report fields.
        // Wrap long content instead of replacing names, statuses or dates with "...".
        const doc = new jsPDF({ orientation: "landscape", format: "a3" });
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFontSize(15);
        doc.text("Projects Report", 14, 15);
        doc.setFontSize(9);
        doc.text(
          `Generated: ${new Date().toLocaleString("en-CA")}   Total: ${rows.length}`,
          14,
          22,
        );
        autoTable(doc, {
          head: [EXPORT_COLS.map((c) => c.label)],
          body: rows.map((o) => EXPORT_COLS.map((c) => getExportVal(o, c.id))),
          startY: 28,
          margin: { left: 12, right: 12, bottom: 15 },
          tableWidth: pageWidth - 24,
          styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak", valign: "middle" },
          headStyles: {
            fillColor: [30, 41, 59],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
          alternateRowStyles: { fillColor: [248, 250, 252] },
          columnStyles: {
            0: { cellWidth: 20 },
            1: { cellWidth: 43 },
            2: { cellWidth: 54 },
            3: { cellWidth: 65 },
            4: { cellWidth: 40 },
            5: { cellWidth: 35 },
            6: { cellWidth: 42 },
            7: { cellWidth: 37 },
            8: { cellWidth: 34 },
            9: { cellWidth: "auto" },
          },
        });
        doc.save(`${filename}.pdf`);
      }
      showSnackbar(`${format === "pdf" ? "PDF" : format === "csv" ? "CSV" : "Excel"} exported successfully`);
    } catch (error) {
      console.error("Failed to export complete Projects report", error);
      showSnackbar("Export failed. No partial report was saved; please retry.", "error");
    } finally {
      setExporting(false);
    }
  };

  const columns = [
    {
      field: "OrderId",
      headerName: "Project ID",
      width: 130,
      renderCell: (params) => (
        <Box>
          <Typography
            variant="body2"
            fontWeight={700}
            sx={{
              fontFamily: "monospace",
              color: "primary.main",
              fontSize: "0.82rem",
            }}
          >
            #{params.row.OrderId}
          </Typography>
          {params.row.EventType && (
            <Typography
              variant="caption"
              sx={{
                color: C.textMuted,
                display: "block",
                lineHeight: 1.3,
                fontSize: "0.68rem",
              }}
            >
              {params.row.EventType}
            </Typography>
          )}
        </Box>
      ),
    },

    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 280,
      renderCell: (params) => {
        const name = params.row.ProjectName || "Untitled";
        const inHands = formatInHandsDate(params.row.inHandsDate);
        const isOverdue =
          params.row.inHandsDate &&
          new Date(params.row.inHandsDate) < new Date();
        return (
          <Box sx={{ overflow: "hidden" }}>
            <Tooltip title={name}>
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{
                  color: C.textPri,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {name}
              </Typography>
            </Tooltip>
            {inHands && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  mt: 0.3,
                }}
              >
                <CalendarTodayIcon
                  sx={{
                    fontSize: 10,
                    color: isOverdue ? "error.main" : C.textMuted,
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: isOverdue ? "error.main" : C.textMuted,
                    fontSize: "0.68rem",
                    fontWeight: isOverdue ? 700 : 400,
                  }}
                >
                  Due {inHands}
                </Typography>
              </Box>
            )}
          </Box>
        );
      },
    },

    {
      field: "customer",
      headerName: "Customer",
      width: 230,
      renderCell: (params) => {
        const rowCustomer = Array.isArray(params.row.customer)
          ? params.row.customer[0]
          : params.row.customer || null;
        const customerData = rowCustomer;

        let logoUrl = "";
        if (customerData?.customUploadedBrandLogo) {
          logoUrl = customerData.customUploadedBrandLogo.startsWith("uploads")
            ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${customerData.customUploadedBrandLogo}`
            : customerData.customUploadedBrandLogo;
        }

        const customerName =
          rowCustomer?.businessName || params.row.CustomerName || "No Customer";

        const initials = customerName.charAt(0).toUpperCase();

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              overflow: "hidden",
            }}
          >
            {logoUrl ? (
              <Box
                component="img"
                src={logoUrl}
                alt=""
                sx={{
                  width: 28,
                  height: 28,
                  objectFit: "contain",
                  borderRadius: 1,
                  flexShrink: 0,
                  border: `1px solid ${C.border}`,
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: 1,
                  flexShrink: 0,
                  backgroundColor: "primary.main",
                  opacity: 0.85,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: "0.7rem", fontWeight: 800, color: C.white }}
                >
                  {initials}
                </Typography>
              </Box>
            )}
            <Box sx={{ overflow: "hidden", minWidth: 0 }}>
              <Typography
                variant="body2"
                fontWeight={500}
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: C.textPri,
                }}
              >
                {customerName}
              </Typography>
              {params.row.Email && (
                <Typography
                  variant="caption"
                  sx={{
                    color: C.textMuted,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    fontSize: "0.68rem",
                  }}
                >
                  {params.row.Email}
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
    },

    {
      field: "OrderStatus",
      headerName: "Status",
      width: 290,
      renderCell: (params) => {
        const statusObj = params.value;
        if (!statusObj) {
          return (
            <Typography variant="caption" color="text.disabled">
              No status
            </Typography>
          );
        }
        const soRaw = canonicalizeSoDisplay(statusObj.SO || "");
        const poRaw = String(statusObj.PO || "").trim();
        const soLabel = soRaw ? getWorkflowLabel("SO", soRaw) : null;
        const poLabel = poRaw ? getWorkflowLabel("PO", poRaw) : null;

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
              py: 0.75,
            }}
          >
            {soLabel && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.63rem",
                    fontWeight: 800,
                    color: C.textMuted,
                    minWidth: 18,
                    letterSpacing: "0.03em",
                  }}
                >
                  SO
                </Typography>
                <UIStatusChip
                  label={soLabel}
                  tone={getSOStatusTone(soRaw)}
                />
              </Box>
            )}
            {poLabel && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.63rem",
                    fontWeight: 800,
                    color: C.textMuted,
                    minWidth: 18,
                    letterSpacing: "0.03em",
                  }}
                >
                  PO
                </Typography>
                <UIStatusChip
                  label={poLabel}
                  tone={getPOStatusTone(poRaw)}
                />
              </Box>
            )}
          </Box>
        );
      },
    },

    {
      field: "AssignedTo",
      headerName: "Team",
      width: 130,
      sortable: false,
      renderCell: (params) => (
        <AssignedUsersColumn
          assigned={params.row.AssignedTo || []}
          allUsers={allUsers}
        />
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: 110,
      sortable: false,
      renderCell: (params) => (
        <UITableActionCell align="flex-start">
          <Button
            variant="outlined"
            size="small"
            startIcon={<VisibilityIcon sx={{ fontSize: "0.85rem !important" }} />}
            onClick={() =>
              history.push(
                `/instance/${instanceUniqueId}/sales/orders/${params.row.OrderId}/overview`,
              )
            }
            sx={{
              fontSize: "0.72rem",
              height: 28,
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              minWidth: 76,
            }}
          >
            View
          </Button>
        </UITableActionCell>
      ),
    },
  ];

  const colRenderMap = useMemo(() => {
    const map = {};
    columns.forEach((c) => {
      if (c.field) map[c.field] = c;
    });
    return map;
  }, [columns]);

  const openOrderPopup = (order) => {
    setSelectedOrder(order);
    setIsOrderPopupOpen(true);
  };

  const closeOrderPopup = () => {
    setIsOrderPopupOpen(false);
    setSelectedOrder(null);
  };

  // Handlers for Create Order modal
  const handleOpenOrderModal = () => {
    setOrderModalOpen(true);
  };

  const handleCloseOrderModal = () => {
    setOrderModalOpen(false);
  };

  const handleOrderCreated = () => {
    const p = new URLSearchParams(location.search);
    if (searchInput) p.set("orderSearchQuery", searchInput);
    else p.delete("orderSearchQuery");
    p.set("tab", orderTab);
    p.set("page", "1");

    pageRef.current.suppressNextOnPageChange = true; // block one stray onPageChange
    setCurrentPage(1);

    navigateWithGuard(p, { replace: true });
    handleSearch(1, searchInput, orderTab);
  };

  //               <div
  //                 className="tabs customers-tabs"
  //                 style={{ marginBottom: 12 }}
  //               >
  //                 {OrderSourceTabs.map(({ key, label, tooltip }) => (
  //                   <Tooltip key={key} title={tooltip} placement="bottom">
  //                     <button
  //                       className={`tab-btn${
  //                         orderTab === key ? " active" : ""
  //                       }`}
  //                       onClick={() => {
  //                         setOrderTab(key);
  //                         setSearchInput("");
  //                         setSoStatusFilter("");
  //                         setPoStatusFilter("");
  //                         setCurrentPage(1);
  //                         // 🆕 reset the skip-first-pageChange guard

  //                         const p = new URLSearchParams();
  //                         p.set("tab", key);
  //                         p.set("page", "1");
  //                         navigateWithGuard(p);
  //                       }}
  //                     >
  //                       {label}
  //                     </button>
  //                   </Tooltip>
  //                 ))}
  //               </div>

  //               <div class="actionBar">
  //                 <button onClick={handleOpenOrderModal}>New Project</button>

  //                 <div className="search-container">
  //                   <TextField
  //                     label="Search projects"
  //                     variant="outlined"
  //                     size="small"
  //                     value={searchInput}
  //                     onChange={(e) => setSearchInput(e.target.value)}
  //                     onKeyDown={(e) => {
  //                       if (e.key === "Enter") {
  //                         e.preventDefault();
  //                         handleSearchButtonClick();
  //                       }
  //                     }}
  //                   />

  //                   <Button
  //                     variant="contained"
  //                     color="primary"
  //                     onClick={handleSearchButtonClick}
  //                   >
  //                     Search
  //                   </Button>

  //                   {orderTab === "allOrders" && canUseAllOrdersFilters && (
  //                     <>
  //                       <FormControl size="small" sx={{ minWidth: 220 }}>
  //                         <InputLabel id="all-orders-so-filter-label">
  //                           SO Status
  //                         </InputLabel>
  //                         <Select
  //                           labelId="all-orders-so-filter-label"
  //                           value={soStatusFilter}
  //                           label="SO Status"
  //                           onChange={(e) => setSoStatusFilter(e.target.value)}
  //                         >
  //                           <MenuItem value="">All SO statuses</MenuItem>
  //                           {STATUS_FILTER_OPTIONS.SO.map((status) => {
  //                             const label = getWorkflowLabel("SO", status);
  //                             const tooltip = getWorkflowTooltip("SO", status);
  //                             return (
  //                               <MenuItem
  //                                 key={status}
  //                                 value={status}
  //                                 title={tooltip || label}
  //                               >
  //                                 {label}
  //                               </MenuItem>
  //                             );
  //                           })}
  //                         </Select>
  //                       </FormControl>

  //                       <FormControl size="small" sx={{ minWidth: 220 }}>
  //                         <InputLabel id="all-orders-po-filter-label">
  //                           PO Status
  //                         </InputLabel>
  //                         <Select
  //                           labelId="all-orders-po-filter-label"
  //                           value={poStatusFilter}
  //                           label="PO Status"
  //                           onChange={(e) => setPoStatusFilter(e.target.value)}
  //                         >
  //                           <MenuItem value="">All PO statuses</MenuItem>
  //                           {STATUS_FILTER_OPTIONS.PO.map((status) => {
  //                             const label = getWorkflowLabel("PO", status);
  //                             const tooltip = getWorkflowTooltip("PO", status);
  //                             return (
  //                               <MenuItem
  //                                 key={status}
  //                                 value={status}
  //                                 title={tooltip || label}
  //                               >
  //                                 {label}
  //                               </MenuItem>
  //                             );
  //                           })}
  //                         </Select>
  //                       </FormControl>
  //                     </>
  //                   )}
  //                 </div>
  //               </div>

  //               {error && <p className="error-text">{error}</p>}

  //               {orders.length > 0 ? (
  //                 <DataTable
  //                   columns={columns}
  //                   rows={orders}
  //                   localeText={{
  //                     MuiTablePagination: {
  //                       labelDisplayedRows: () => {
  //                         const from = (currentPage - 1) * 12 + 1;
  //                         const to = Math.min(currentPage * 12, totalResults);
  //                         return `${from}–${to} of ${totalResults}`;
  //                       },
  //                     },
  //                   }}
  //                   //key={`${orderTab}-${searchInput}-${currentPage}`}
  //                   // tell DataGrid to page on the server
  //                   paginationMode="server"
  //                   rowCount={totalResults} // <-- you'll need to track `TotalResults` in state
  //                   page={currentPage - 1} // zero‑based index
  //                   pageSize={12}
  //                   rowsPerPageOptions={[12]}
  //                   onPageChange={(newPageIndex) => {
  //                     // If this event was triggered by our own programmatic navigation, ignore it once.
  //                     if (pageRef.current.suppressNextOnPageChange) {
  //                       pageRef.current.suppressNextOnPageChange = false;
  //                       return;
  //                     }
  //                     const nextPage = newPageIndex + 1;
  //                     const safe = Math.max(
  //                       1,
  //                       Math.min(nextPage, totalPages || 1),
  //                     );
  //                     if (safe === currentPage) return;
  //                     const params = new URLSearchParams(location.search);
  //                     if (searchInput)
  //                       params.set("orderSearchQuery", searchInput);
  //                     else params.delete("orderSearchQuery");
  //                     params.set("page", String(safe));
  //                     params.set("tab", orderTab);
  //                     if (orderTab === "allOrders") {
  //                       if (soStatusFilter)
  //                         params.set("soStatus", soStatusFilter);
  //                       else params.delete("soStatus");
  //                       if (poStatusFilter)
  //                         params.set("poStatus", poStatusFilter);
  //                       else params.delete("poStatus");
  //                     } else {
  //                       params.delete("soStatus");
  //                       params.delete("poStatus");
  //                     }
  //                     navigateWithGuard(params);
  //                   }}
  //                 />
  //               ) : (
  //                 <p className="no-orders-text">
  //                   No orders found. Try searching for an project ID.
  //                 </p>
  //               )}
  //             </div>
  //           </div>

  //           {selectedOrder && (
  //             <OrderPopup
  //               isOpen={isOrderPopupOpen}
  //               onRequestClose={closeOrderPopup}
  //               orderId={selectedOrder.id}
  //               orderData={selectedOrder}
  //             />
  //           )}

  //           <CreateOrderModal
  //             open={orderModalOpen}
  //             onClose={handleCloseOrderModal}
  //             onOrderCreated={handleOrderCreated}
  //             customers={customerList}
  //           />
  //         </>
  //       )}
  //     </div>
  //   </div>
  // );

  const hasActiveFilters = !!(
    searchInput ||
    soStatusFilter ||
    poStatusFilter ||
    customerFilter
  );

  const handleClearFilters = () => {
    setSearchInput("");
    setSoStatusFilter("");
    setPoStatusFilter("");
    setCustomerFilter("");
    const p = new URLSearchParams();
    p.set("tab", orderTab);
    p.set("page", "1");
    navigateWithGuard(p);
  };

  return (
    <div className="instance-dashboard instance-orders-page">
      <InstanceLeftSidebar />
      <ToastContainer />
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />

      <div className="rightSide">
        <Box
          sx={{
            p: { xs: 1, md: 2 },
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 60px)",
            overflow: "hidden",
            width: "100%"
          }}
        >
          <UITableShell
            customLayout
            paperSx={{
              flex: 1,
              borderRadius: "10px",
              border: "1px solid",
              borderColor: "divider",
              borderTop: "3px solid",
              borderTopColor: "primary.main",
              minHeight: 0,
              boxShadow:
                "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
            }}
          >
            <UITableToolbar sx={{ backgroundColor: C.paperBg }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={1.5}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1.5}
                  flexWrap="wrap"
                  useFlexGap
                >
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ color: C.textPri, lineHeight: 1 }}
                  >
                    Projects
                  </Typography>

                  <Chip
                    label={`${totalResults} total`}
                    size="small"
                    sx={{
                      backgroundColor: "var(--ec-status-neutral-bg)",
                      color: "var(--ec-status-neutral-text)",
                      border: "1px solid var(--ec-status-neutral-border)",
                      fontWeight: 600,
                      fontSize: "0.72rem",
                      height: 22,
                    }}
                  />

                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ height: 20, alignSelf: "center" }}
                  />

                  <Stack direction="row" spacing={0.5}>
                    {OrderSourceTabs.map(({ key, label, tooltip }) => (
                      <Tooltip key={key} title={tooltip} placement="bottom">
                        <Chip
                          label={label}
                          size="small"
                          onClick={() => {
                            setOrderTab(key);
                            setSearchInput("");
                            setSoStatusFilter("");
                            setPoStatusFilter("");
                            setCurrentPage(1);
                            const p = new URLSearchParams();
                            p.set("tab", key);
                            p.set("page", "1");
                            navigateWithGuard(p);
                          }}
                          sx={{
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: "0.72rem",
                            height: 26,
                            backgroundColor:
                              orderTab === key
                                ? "var(--ec-color-primary)"
                                : "var(--ec-status-neutral-bg)",
                            color:
                              orderTab === key
                                ? "var(--ec-color-surface)"
                                : "var(--ec-status-neutral-text)",
                            border:
                              orderTab === key
                                ? "1px solid transparent"
                                : "1px solid var(--ec-status-neutral-border)",
                            transition: "all 0.15s ease",
                            "& .MuiChip-label": { px: "10px" },
                            "&:hover": {
                              backgroundColor:
                                orderTab === key
                                  ? "var(--ec-color-primary-dark)"
                                  : "var(--ec-color-surface-muted)",
                            },
                          }}
                        />
                      </Tooltip>
                    ))}
                  </Stack>

                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ height: 20, alignSelf: "center" }}
                  />

                  {orderTab === "allOrders" && canUseAllOrdersFilters && (
                    <Stack
                      direction="row"
                      spacing={0.5}
                      flexWrap="wrap"
                      useFlexGap
                    >
                      {[
                        { label: "In Production", value: "In Production" },
                        { label: "Client Approved", value: "Client Approved" },
                        {
                          label: "Ready to Invoice",
                          value: "Ready to be Invoiced",
                        },
                        { label: "Quote Requested", value: "Quote Requested" },
                      ].map(({ label, value }) => (
                        <UIStatusChip
                          key={value}
                          label={label}
                          tone={getSOStatusTone(value)}
                          selected={soStatusFilter === value}
                          onClick={() =>
                            setSoStatusFilter((prev) =>
                              prev === value ? "" : value,
                            )
                          }
                          sx={{ cursor: "pointer" }}
                        />
                      ))}
                    </Stack>
                  )}
                </Stack>

                <Stack direction="row" spacing={0.5} alignItems="center">
                  <ToggleButtonGroup
                    exclusive
                    size="small"
                    value={projectViewMode}
                    onChange={(_, value) => setProjectViewMode(value)}
                    sx={{
                      mr: 0.5,
                      "& .MuiToggleButton-root": {
                        height: 32,
                        px: 1.25,
                        textTransform: "none",
                        fontWeight: 700,
                        borderColor: "divider",
                      },
                      "& .Mui-selected": {
                        color: "var(--ec-color-surface) !important",
                        backgroundColor: "var(--ec-color-primary) !important",
                      },
                    }}
                  >
                    <ToggleButton value="table" aria-label="Table view">
                      <TableChartIcon sx={{ fontSize: 17, mr: 0.6 }} />
                      Table
                    </ToggleButton>
                    <ToggleButton value="kanban" aria-label="Kanban view">
                      <ViewKanbanIcon sx={{ fontSize: 17, mr: 0.6 }} />
                      Kanban
                    </ToggleButton>
                  </ToggleButtonGroup>

                  {projectViewMode === "table" && (
                    <>
                  <Tooltip title="Export data">
                    <IconButton
                      size="small"
                      onClick={(e) => setExportAnchorEl(e.currentTarget)}
                      disabled={loading || exporting || totalResults === 0}
                      sx={{ color: "text.secondary" }}
                    >
                      <DownloadIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={exportAnchorEl}
                    open={Boolean(exportAnchorEl)}
                    onClose={() => setExportAnchorEl(null)}
                    slotProps={{
                      paper: { sx: { minWidth: 190, borderRadius: 2 } },
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{
                        px: 2,
                        pt: 1.25,
                        pb: 0.5,
                        display: "block",
                        color: "text.disabled",
                      }}
                    >
                      Export as
                    </Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    <MenuItem
                      onClick={() => {
                        exportProjects("csv");
                        setExportAnchorEl(null);
                      }}
                      sx={{ py: 0.75 }}
                    >
                      <ListItemIcon>
                        <FileDownloadIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>CSV</ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        exportProjects("excel");
                        setExportAnchorEl(null);
                      }}
                      sx={{ py: 0.75 }}
                    >
                      <ListItemIcon>
                        <TableChartIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Excel</ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        exportProjects("pdf");
                        setExportAnchorEl(null);
                      }}
                      sx={{ py: 0.75 }}
                    >
                      <ListItemIcon>
                        <PictureAsPdfIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>PDF</ListItemText>
                    </MenuItem>
                  </Menu>

                  <Tooltip title="Show / hide columns">
                    <IconButton
                      size="small"
                      onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <ViewColumnIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={columnMenuAnchor}
                    open={Boolean(columnMenuAnchor)}
                    onClose={() => setColumnMenuAnchor(null)}
                    slotProps={{
                      paper: { sx: { minWidth: 210, borderRadius: 2 } },
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{
                        px: 2,
                        pt: 1.25,
                        pb: 0.5,
                        display: "block",
                        color: "text.disabled",
                      }}
                    >
                      Columns
                    </Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    {ALL_COLUMNS.filter((c) => !c.locked).map((col) => (
                      <MenuItem
                        key={col.id}
                        onClick={() => toggleColVisibility(col.id)}
                        sx={{ py: 0.4 }}
                      >
                        <Checkbox
                          size="small"
                          checked={visibleColumns.has(col.id)}
                          sx={{
                            p: 0.5,
                            mr: 0.5,
                            color: "primary.main",
                            "&.Mui-checked": { color: "primary.main" },
                          }}
                        />
                        <ListItemText
                          primaryTypographyProps={{ fontSize: "0.875rem" }}
                        >
                          {col.label}
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  <Tooltip title="Row density">
                    <IconButton
                      size="small"
                      onClick={(e) => setDensityMenuAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <SettingsIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={densityMenuAnchor}
                    open={Boolean(densityMenuAnchor)}
                    onClose={() => setDensityMenuAnchor(null)}
                    slotProps={{
                      paper: { sx: { minWidth: 180, borderRadius: 2 } },
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{
                        px: 2,
                        pt: 1.25,
                        pb: 0.5,
                        display: "block",
                        color: "text.disabled",
                      }}
                    >
                      Row density
                    </Typography>
                    {["compact", "comfortable", "spacious"].map((d) => (
                      <MenuItem
                        key={d}
                        onClick={() => {
                          setDensity(d);
                          setDensityMenuAnchor(null);
                        }}
                        sx={{ py: 0.75, textTransform: "capitalize" }}
                      >
                        <Checkbox
                          size="small"
                          checked={density === d}
                          sx={{
                            p: 0.5,
                            mr: 0.5,
                            color: "primary.main",
                            "&.Mui-checked": { color: "primary.main" },
                          }}
                        />
                        <ListItemText
                          primaryTypographyProps={{
                            fontSize: "0.875rem",
                            textTransform: "capitalize",
                          }}
                        >
                          {d}
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  <Tooltip title="Refresh list">
                    <IconButton
                      size="small"
                      onClick={() => {
                        handleSearch(
                          currentPage,
                          searchInput,
                          orderTab,
                          customerFilter,
                          soStatusFilter,
                          poStatusFilter,
                        );
                        showSnackbar("Data refreshed", "success");
                      }}
                      sx={{
                        // border: "1px solid",
                        // borderColor: "divider",
                        // borderRadius: 1.5,
                        // width: 34,
                        // height: 34,
                        color: "text.secondary",
                      }}
                    >
                      <RefreshIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ mx: 0.5, height: 24, alignSelf: "center" }}
                  />
                    </>
                  )}

                  {projectViewMode === "kanban" && (
                    <Tooltip title="Refresh board">
                      <IconButton
                        size="small"
                        onClick={() => setKanbanRefreshKey((current) => current + 1)}
                        sx={{ color: "text.secondary" }}
                      >
                        <RefreshIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleOpenOrderModal}
                    sx={{
                      fontWeight: 700,
                      textTransform: "none",
                      height: 34,
                      px: 2,
                      whiteSpace: "nowrap",
                    }}
                  >
                    New Project
                  </Button>
                </Stack>
              </Stack>

              {/* divider between title row and filter row */}
              <Divider sx={{ mt: 1.75, mb: 0 }} />

              <Stack
                direction="row"
                spacing={1.5}
                mt={1.75}
                flexWrap="wrap"
                useFlexGap
                alignItems="center"
              >
              

                {/* Search field */}
                <TextField
                  placeholder="Search project ID or name…"
                  size="small"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearchButtonClick();
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 16, color: C.textMuted }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchInput ? (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => setSearchInput("")}
                          edge="end"
                        >
                          <ClearIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={{
                    // flex: 1,               // grows to fill space
                    flex: 2,
                    minWidth: 280,
                    // maxWidth: 420,
                    // "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                    "& .MuiOutlinedInput-root": { backgroundColor: "var(--ec-input-bg)" },
                  }}
                />

                {/* <Button
                variant="outlined"
                size="small"
                onClick={handleSearchButtonClick}
                sx={{ height: 40, textTransform: "none", fontWeight: 600, px: 2.5 }}
              >
                Search
              </Button> */}

                {/* Search button */}
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<SearchIcon sx={{ fontSize: 15 }} />}
                  onClick={handleSearchButtonClick}
                  sx={{
                    height: 40,
                    textTransform: "none",
                    fontWeight: 600,
                    px: 2.5,
                    boxShadow: "none",
                    "&:hover": { boxShadow: "none" },
                  }}
                >
                  Search
                </Button>

                {hasActiveFilters && (
                  <Tooltip title="Clear all filters">
                    <Button
                      variant="text"
                      size="small"
                      startIcon={<ClearIcon sx={{ fontSize: 14 }} />}
                      onClick={handleClearFilters}
                      sx={{
                        height: 40,
                        textTransform: "none",
                        fontWeight: 600,
                        color: "text.secondary",
                        px: 1.5,
                        "&:hover": {
                          color: "error.main",
                          backgroundColor: "var(--ec-status-error-bg)",
                        },
                      }}
                    >
                      Clear
                    </Button>
                  </Tooltip>
                )}

                {orderTab === "allOrders" && canUseAllOrdersFilters && (
                  <>
                    <FormControl
                      size="small"
                      sx={{
                        flex: 1,
                        minWidth: 190,
                        // "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                        // "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                      }}
                    >
                      <InputLabel id="so-filter-label">SO Status</InputLabel>
                      <Select
                        labelId="so-filter-label"
                        value={soStatusFilter}
                        label="SO Status"
                        onChange={(e) => setSoStatusFilter(e.target.value)}
                        //  sx={{ backgroundColor: "#f8fafc" }}
                        sx={{ backgroundColor: "var(--ec-input-bg)" }}
                      >
                        <MenuItem value="">All SO statuses</MenuItem>
                        {STATUS_FILTER_OPTIONS.SO.map((status) => (
                          <MenuItem
                            key={status}
                            value={status}
                            title={getWorkflowTooltip("SO", status)}
                          >
                            {getWorkflowLabel("SO", status)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      size="small"
                      sx={{
                        flex: 1,
                        minWidth: 190,

                        // "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                        // "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                      }}
                    >
                      <InputLabel id="po-filter-label">PO Status</InputLabel>
                      <Select
                        labelId="po-filter-label"
                        value={poStatusFilter}
                        label="PO Status"
                        onChange={(e) => setPoStatusFilter(e.target.value)}
                        //  sx={{ backgroundColor: "#f8fafc" }}
                        sx={{ backgroundColor: "var(--ec-input-bg)" }}
                      >
                        <MenuItem value="">All PO statuses</MenuItem>
                        {STATUS_FILTER_OPTIONS.PO.map((status) => (
                          <MenuItem
                            key={status}
                            value={status}
                            title={getWorkflowTooltip("PO", status)}
                          >
                            {getWorkflowLabel("PO", status)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </>
                )}
              </Stack>

              {/* Active filter chips */}
              {hasActiveFilters && (
                <Stack
                  direction="row"
                  spacing={0.75}
                  mt={1.25}
                  flexWrap="wrap"
                  useFlexGap
                  alignItems="center"
                >
                  <Typography
                    variant="caption"
                    sx={{ color: C.textMuted, fontWeight: 600, mr: 0.25 }}
                  >
                    Active filters:
                  </Typography>

                  {searchInput && (
                    <Chip
                      label={`Search: "${searchInput}"`}
                      size="small"
                      onDelete={() => {
                        setSearchInput("");
                        handleSearchButtonClick();
                      }}
                      sx={{
                        backgroundColor: "var(--ec-status-info-bg)",
                        color: "var(--ec-status-info-text)",
                        border: "1px solid var(--ec-status-info-border)",
                        fontWeight: 600,
                        fontSize: "0.72rem",
                      }}
                    />
                  )}

                  {soStatusFilter && (
                    <UIStatusChip
                      label={`SO: ${soStatusFilter}`}
                      tone={getSOStatusTone(soStatusFilter)}
                      onDelete={() => {
                        setSoStatusFilter("");
                        const p = new URLSearchParams(location.search);
                        p.delete("soStatus");
                        p.set("page", "1");
                        navigateWithGuard(p);
                      }}
                    />
                  )}

                  {poStatusFilter && (
                    <UIStatusChip
                      label={`PO: ${poStatusFilter}`}
                      tone={getPOStatusTone(poStatusFilter)}
                      onDelete={() => {
                        setPoStatusFilter("");
                        const p = new URLSearchParams(location.search);
                        p.delete("poStatus");
                        p.set("page", "1");
                        navigateWithGuard(p);
                      }}
                    />
                  )}

                  {customerFilter && (
                    <Chip
                      label="Customer filter active"
                      size="small"
                      onDelete={() => {
                        setCustomerFilter("");
                        handleClearFilters();
                      }}
                      sx={{
                        backgroundColor: "var(--ec-status-neutral-bg)",
                        color: "var(--ec-status-neutral-text)",
                        border: "1px solid var(--ec-status-neutral-border)",
                        fontWeight: 600,
                        fontSize: "0.72rem",
                      }}
                    />
                  )}

                  <Chip
                    label="Clear all"
                    size="small"
                    onClick={handleClearFilters}
                    deleteIcon={<ClearIcon />}
                    sx={{
                      backgroundColor: "var(--ec-status-error-bg)",
                      color: "var(--ec-status-error-text)",
                      border: "1px solid var(--ec-status-error-border)",
                      fontWeight: 700,
                      fontSize: "0.72rem",
                      cursor: "pointer",
                    }}
                  />
                </Stack>
              )}
            </UITableToolbar>

            {projectViewMode === "kanban" ? (
              <Box sx={{ flex: 1, minHeight: 0, p: 1.5, backgroundColor: "#f8fafc" }}>
                <PipelineBoard
                  instanceUniqueId={instanceUniqueId}
                  embedded
                  initialQuery={pipelineQuery}
                  pageSize={25}
                  height="100%"
                  showHeader={false}
                  assignedTo={orderTab === "myOrders" ? authState?.id : undefined}
                  refreshKey={kanbanRefreshKey}
                  enableAutoRefresh
                />
              </Box>
            ) : (
              <>
            <TableContainer
              sx={{
                flex: 1,
                overflow: "auto",
                minHeight: 0,
                //  borderRadius: 0,
                borderRadius: "0 !important",
                "&::-webkit-scrollbar": { width: 6, height: 6 },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "var(--ec-color-border-strong)",
                  borderRadius: 99,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {/* <Table stickyHeader size="small" sx={{ minWidth: 800 }}> */}
              <Table
                stickyHeader
                size="small"
                sx={{ minWidth: 800, width: "100%" }}
              >
                <TableHead>
                  <TableRow>
                    {ALL_COLUMNS.filter((c) => visibleColumns.has(c.id)).map(
                      (col, idx, arr) => (
                        <TableCell
                          key={col.id}
                          align={col.id === "actions" ? "center" : "left"}
                          // onClick={() => col.sortable && handleSort(col.field)}
                          onClick={() => col.sortable && handleSort(col.id)}
                          sx={{
                            minWidth: col.minWidth,
                            px: 2,
                            py: 1.25,
                            // backgroundColor: "var(--ec-table-head-bg-strong) !important",
                            backgroundColor: '#f8fafc !important',     
                            // backgroundColor: 'var(--color-surface-offset) !important',
                            color:
                              sortBy === col.id
                                ? "var(--ec-table-head-text-inverse)"
                                : "var(--ec-table-head-text-muted)",
                            fontWeight: 700,
                            fontSize: "0.72rem",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            borderBottom: "none",
                            cursor: col.sortable ? "pointer" : "default",
                            userSelect: "none",
                            whiteSpace: "nowrap",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            transition: "all 0.15s",
                            "&:hover": col.sortable
                              ? {
                                  backgroundColor: "var(--ec-table-head-bg-hover) !important",
                                  color: "var(--ec-table-head-text-inverse)",
                                }
                              : {},
                            // ...(idx === 0           && { borderTopLeftRadius:  "9px" }),
                            //     ...(idx === arr.length - 1 && { borderTopRightRadius: "9px" }),
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,

                              justifyContent:
                                col.id === "actions" ? "center" : "flex-start",
                            }}
                          >
                            {col.label}
                            {col.sortable && (
                              <Box
                                sx={{
                                  display: "inline-flex",
                                  ml: 0.25,

                                  opacity: sortBy === col.id ? 1 : 0.4,
                                  color:
                                    sortBy === col.id
                                      ? "var(--ec-table-head-text-inverse)"
                                      : "var(--ec-color-text-muted)",
                                }}
                              >
                                {/* {sortBy === col.field ? ( */}
                                {sortBy === col.id ? (
                                  sortDir === "asc" ? (
                                    <ArrowUpwardIcon sx={{ fontSize: 12 }} />
                                  ) : (
                                    <ArrowDownwardIcon sx={{ fontSize: 12 }} />
                                  )
                                ) : (
                                  <UnfoldMoreIcon sx={{ fontSize: 13 }} />
                                )}
                              </Box>
                            )}
                          </Box>
                        </TableCell>
                      ),
                    )}
                  </TableRow>
                </TableHead>

                <TableBody
                  sx={{
                    "& .MuiTableCell-root": {
                      borderBottom: `1px solid ${C.border}`,
                    },
                    "& .MuiTableRow-root:last-child .MuiTableCell-root": {
                      borderBottom: "none",
                    },
                  }}
                >
                  {/* Loading skeleton */}
                  {(loading || workflowSettingsLoading) &&
                    [...Array(8)].map((_, i) => (
                      <TableRow key={i}>
                        {ALL_COLUMNS.filter((c) =>
                          visibleColumns.has(c.id),
                        ).map((col) => (
                          <TableCell
                            key={col.id}
                            sx={{ px: 2, py: currentDensity.py }}
                          >
                            <Skeleton
                              variant="rectangular"
                              height={20}
                              sx={{ borderRadius: 1, opacity: 1 - i * 0.09 }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}

                  {/* Error state */}
                  {!loading && !workflowSettingsLoading && error && (
                    <TableRow>
                      <TableCell
                        // colSpan={ALL_COLUMNS.filter(c => visibleColumns.has(c.field)).length}
                        colSpan={
                          ALL_COLUMNS.filter((c) => visibleColumns.has(c.id))
                            .length
                        }
                        sx={{ py: 5, px: 3 }}
                      >
                        <Alert severity="error">{error}</Alert>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Empty state */}
                  {!loading &&
                    !workflowSettingsLoading &&
                    !error &&
                    sortedOrders.length === 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={
                            ALL_COLUMNS.filter((c) => visibleColumns.has(c.id))
                              .length
                          } // ← was c.field (BUG)
                          align="center"
                          sx={{
                            py: 8,
                            borderBottom: "none",
                            background: "transparent",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                width: 64,
                                height: 64,
                                borderRadius: "50%",
                                backgroundColor: "var(--ec-color-surface-muted)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <FolderOffIcon
                                sx={{ fontSize: 32, color: "var(--ec-color-text-muted)" }}
                              />
                            </Box>
                            <Box sx={{ textAlign: "center" }}>
                              <Typography
                                variant="h6"
                                fontWeight={600}
                                color="text.secondary"
                                gutterBottom
                              >
                                No projects found
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.disabled"
                                sx={{ maxWidth: 340 }}
                              >
                                {hasActiveFilters
                                  ? "No projects match your current search or filters."
                                  : "You don't have any projects yet. Create your first project to get started."}
                              </Typography>
                            </Box>
                            <Stack direction="row" spacing={1.5} mt={0.5}>
                              {hasActiveFilters && (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  startIcon={<ClearIcon />}
                                  onClick={handleClearFilters}
                                  sx={{
                                    textTransform: "none",
                                    fontWeight: 600,
                                  }}
                                >
                                  Clear Filters
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={handleOpenOrderModal}
                                sx={{ textTransform: "none", fontWeight: 700 }}
                              >
                                New Project
                              </Button>
                            </Stack>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}

                  {!loading &&
                    !workflowSettingsLoading &&
                    !error &&
                    sortedOrders.map((order, index) => (
                      <TableRow
                        key={order.OrderId || index}
                        hover
                        onClick={() =>
                          history.push(
                            `/instance/${instanceUniqueId}/sales/orders/${order.OrderId}/overview`,
                          )
                        }
                        sx={{
                          cursor: "pointer",
                          backgroundColor: C.paperBg,
                          transition: "background-color 0.1s",
                          "&:hover": { backgroundColor: C.subtleBg },
                        }}
                      >
                        {ALL_COLUMNS.filter((c) =>
                          visibleColumns.has(c.id),
                        ).map((col) => {
                          //                         const colDef = col.field ? colRenderMap[col.field] : null;
                          // const cellContent = colDef?.renderCell
                          //   ? colDef.renderCell({ row: order, value: order[col.field] })
                          //   : col.id === "s_no"
                          //     ? index + 1
                          //     : col.id === "date_created"
                          //       ? (order.createdAt ? new Date(order.createdAt).toLocaleDateString("en-CA") : "—")
                          //       : (order[col.id] ?? "—");

                          const cellContent = (() => {
                            // if (col.id === "s_no")        return index + 1;

                            if (col.id === "s_no")
                              return (
                                (currentPage - 1) * rowsPerPage + index + 1
                              );
                            if (col.id === "date_created")
                              return order.createdAt
                                ? new Date(
                                    order.createdAt,
                                  ).toLocaleDateString("en-CA", {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric",
                                  })
                                : "—";

                            // SO Status only the SO chip
                            if (col.id === "so_status") {
                              const raw = canonicalizeSoDisplay(
                                order.OrderStatus?.SO || "",
                              );
                              if (!raw)
                                return (
                                  <Typography
                                    variant="caption"
                                    color="text.disabled"
                                  >
                                    —
                                  </Typography>
                                );
                              return (
                                <UIStatusChip
                                  label={getWorkflowLabel("SO", raw)}
                                  tone={getSOStatusTone(raw)}
                                />
                              );
                            }

                            // PO Status only the PO chip
                            if (col.id === "po_status") {
                              const raw = String(
                                order.OrderStatus?.PO || "",
                              ).trim();
                              if (!raw)
                                return (
                                  <Typography
                                    variant="caption"
                                    color="text.disabled"
                                  >
                                    —
                                  </Typography>
                                );
                              return (
                                <UIStatusChip
                                  label={getWorkflowLabel("PO", raw)}
                                  tone={getPOStatusTone(raw)}
                                />
                              );
                            }

                         
                            const colDef = col.field
                              ? colRenderMap[col.field]
                              : null;
                            if (colDef?.renderCell)
                              return colDef.renderCell({
                                row: order,
                                value: order[col.field],
                              });

                            return order[col.id] ?? "—";
                          })();

                          const stopClick =
                            col.field === "action"
                              ? { onClick: (e) => e.stopPropagation() }
                              : {};

                          return (
                            <TableCell
                              key={col.id}
                              align={col.id === "actions" ? "center" : "left"}
                              sx={{
                                px: 2,
                                py: currentDensity.py,
                                fontSize: currentDensity.fontSize,
                                color: C.textPri,
                                verticalAlign: "middle",

                                ...(col.field === "OrderStatus"
                                  ? { verticalAlign: "middle" }
                                  : {}),
                              }}
                              {...stopClick}
                            >
                              {cellContent}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

      

            <Box
              sx={{
                px: 2,
                py: 0,
                backgroundColor: C.paperBg,
                borderTop: `1px solid ${C.border}`,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                minHeight: 52,
              }}
            >
              {/* Left side record count */}
              <Typography
                variant="body2"
                sx={{ color: "var(--ec-color-text-muted)", fontSize: "0.8125rem", pl: 1 }}
              >
                {totalResults > 0
                  ? `Showing ${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                      currentPage * rowsPerPage,
                      totalResults,
                    )} of ${totalResults} project${
                      totalResults !== 1 ? "s" : ""
                    }`
                  : loading
                  ? ""
                  : "No results"}
              </Typography>

              {/* Right side pagination */}
              <TablePagination
                component="div"
                count={totalResults}
                page={currentPage - 1}
                onPageChange={(_, newPage) => {
                  if (pageRef.current.suppressNextOnPageChange) {
                    pageRef.current.suppressNextOnPageChange = false;
                    return;
                  }
                  const safe = Math.max(
                    1,
                    Math.min(newPage + 1, totalPages || 1),
                  );
                  if (safe === currentPage) return;
                  const params = new URLSearchParams(location.search);
                  if (searchInput) params.set("orderSearchQuery", searchInput);
                  else params.delete("orderSearchQuery");
                  params.set("page", String(safe));
                  params.set("tab", orderTab);
                  if (orderTab === "allOrders") {
                    if (soStatusFilter) params.set("soStatus", soStatusFilter);
                    else params.delete("soStatus");
                    if (poStatusFilter) params.set("poStatus", poStatusFilter);
                    else params.delete("poStatus");
                  } else {
                    params.delete("soStatus");
                    params.delete("poStatus");
                  }
                  navigateWithGuard(params);
                }}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  const newRpp = parseInt(e.target.value, 10);
                  setRowsPerPage(newRpp);
                  handleSearch(
                    1,
                    searchInput,
                    orderTab,
                    customerFilter,
                    soStatusFilter,
                    poStatusFilter,
                  );
                }}
                rowsPerPageOptions={[12, 25, 50]}
                sx={{
                  border: 0,
                  "& .MuiTablePagination-toolbar": {
                    minHeight: 52,
                    px: 0,
                    alignItems: "center",
                  },
                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                    fontSize: "0.8125rem",
                    color: "var(--ec-color-text-muted) !important",
                    mb: 0,
                    lineHeight: 1,
                  },
                  "& .MuiTablePagination-select": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Box>
              </>
            )}
          </UITableShell>
        </Box>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%", fontWeight: 600 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {selectedOrder && (
        <OrderPopup
          isOpen={isOrderPopupOpen}
          onRequestClose={closeOrderPopup}
          orderId={selectedOrder.id}
          orderData={selectedOrder}
        />
      )}

      <CreateOrderModal
        open={orderModalOpen}
        onClose={handleCloseOrderModal}
        onOrderCreated={handleOrderCreated}
        customers={customerList}
      />
    </div>
  );
}

export default InstanceOrders;

//
// ==============================
// OrderPopup Component – Complex Popup for a Single Order
// ==============================
const OrderPopup = ({ isOpen, onRequestClose, orderId, orderData }) => {
  const [activeTab, setActiveTab] = useState("Overview");
  const [activePOTab, setActivePOTab] = useState("Purchase Orders");
  const [showPopup, setShowPopup] = useState(false);

  // State for rep assignments in Overview tab
  const [orderRep, setOrderRep] = useState("");
  const [clientRep, setClientRep] = useState("");

  const fakeFiles = Array.from({ length: 12 }, (_, index) => ({
    id: index,
    url: `https://placehold.co/150x150?text=File+${index + 1}`,
  }));

  const fakePurchaseOrders = [
    {
      id: 201,
      productImage: "https://placehold.co/50x50?text=Img",
      sku: "SKU-001",
      poNumber: "PO-12345",
      details: "Order details here",
      status: "Pending",
      supplier: "Supplier A",
      productionRep: "John Doe",
    },
    {
      id: 202,
      productImage: "https://placehold.co/50x50?text=Img",
      sku: "SKU-002",
      poNumber: "PO-12346",
      details: "Order details here",
      status: "Shipped",
      supplier: "Supplier B",
      productionRep: "Jane Smith",
    },
  ];

  const purchaseOrderColumns = [
    { field: "id", headerName: "Order ID", width: 150 },
    { field: "supplier", headerName: "Supplier", width: 200 },
    { field: "status", headerName: "Status", width: 150 },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="purchase-order-actions">
          <button onClick={() => handleEmailPurchaseOrder(params.row)}>
            Email
          </button>
          <button onClick={() => handleDeletePurchaseOrder(params.row)}>
            Delete
          </button>
        </div>
      ),
    },
  ];

  const [purchaseOrders, setPurchaseOrders] = useState(fakePurchaseOrders);
  const [orderLoading, setOrderLoading] = useState(false);

  const [proofsList, setProofsList] = useState([]);
  const [proofLoading, setProofLoading] = useState(false);
  const [allProofsUploaded, setAllProofsUploaded] = useState(false);

  const [quoteAddress, setQuoteAddress] = useState("");

  const handleEmailPurchaseOrder = (po) => {
    console.log("Sending email for Purchase Order:", po.poNumber);
  };

  const handleDeletePurchaseOrder = (po) => {
    setPurchaseOrders((prevOrders) => prevOrders.filter((o) => o.id !== po.id));
    console.log("Deleted Purchase Order ID:", po.id);
  };

  const handleAddNewProof = () => {
    const newProof = {
      id: Date.now(),
      image: "",
      fileName: "",
      status: "Proof received",
      comment: "",
      comments: [],
    };
    setProofsList([...proofsList, newProof]);
  };

  const handleUpdateProof = (index, updatedProof) => {
    const newProofs = proofsList.slice();
    newProofs[index] = updatedProof;
    setProofsList(newProofs);
  };

  const handleDeleteProof = (index) => {
    const newProofs = proofsList.filter((_, i) => i !== index);
    setProofsList(newProofs);
  };

  const handleUploadProof = (proof) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      const newProof = { ...proof, image: file.name, status: "Created" };
      setProofsList((prevProofs) => [...prevProofs, newProof]);
      console.log("Uploaded proof:", newProof);
    };
    fileInput.click();
  };

  const handleChangeProofStatus = (proof) => {
    const updatedProof = { ...proof, status: "Submitted" };
    setProofsList((prevProofs) =>
      prevProofs.map((p) => (p.id === proof.id ? updatedProof : p)),
    );
  };

  if (!isOpen) return null;
  return (
    <div className="popup order-popup-container">
      <div className="popup_inner order-popup-inner">
        <div className="popup_header">
          <div>
            <h1 className="order-popup-header">
              Order Details (Order #{orderId})
            </h1>
            <div className="status-bubble">{orderData.status}</div>
          </div>
          <button onClick={onRequestClose} className="close-button">
            Close
          </button>
        </div>
        <div className="order-tabs">
          <button onClick={() => setActiveTab("Overview")}>Overview</button>
          <button onClick={() => setActiveTab("Files")}>Files</button>
          <button onClick={() => setActiveTab("Presentation")}>
            Presentation
          </button>
          <button onClick={() => setActiveTab("Estimate")}>Estimate</button>
          <button onClick={() => setActiveTab("Sales Order")}>
            Sales Order
          </button>
          <button onClick={() => setActiveTab("Shipping")}>Shipping</button>
          <button onClick={() => setActiveTab("POs/Proofs")}>POs/Proofs</button>
          <button onClick={() => setActiveTab("Invoice")}>Invoice</button>
          <button onClick={() => setActiveTab("Commissions")}>
            Commissions
          </button>
        </div>
        <div className="order-tab-content">
          {activeTab === "Overview" && (
            <div className="order-overview">
              <h3>Overview</h3>
              <p>
                Order summary, customer information, and general order details:
              </p>
              <p>
                <strong>Customer:</strong> {orderData.customer}
              </p>
              <p>
                <strong>Date:</strong> {orderData.date}
              </p>
              <p>
                <strong>Total:</strong> {orderData.total}
              </p>
              <p>
                <strong>Status:</strong> {orderData.status}
              </p>
              <div className="form-group">
                <label>Order Rep:</label>
                <select
                  value={orderRep}
                  onChange={(e) => setOrderRep(e.target.value)}
                >
                  <option value="">Select Order Rep</option>
                  <option value="John Doe">John Doe</option>
                  <option value="Jane Doe">Jane Doe</option>
                </select>
              </div>
              <div className="form-group">
                <label>Client Rep:</label>
                <select
                  value={clientRep}
                  onChange={(e) => setClientRep(e.target.value)}
                >
                  <option value="">Select Client Rep</option>
                  <option value="Alice Smith">Alice Smith</option>
                  <option value="Bob Johnson">Bob Johnson</option>
                </select>
              </div>
            </div>
          )}
          {activeTab === "Files" && (
            <div className="order-files">
              <h3>Files</h3>
              <p>The customer's file library is shown below.</p>
              <div className="files-grid">
                {fakeFiles.map((file) => (
                  <div key={file.id} className="file-tile">
                    <img src={file.url} alt={`File ${file.id}`} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {activeTab === "Presentation" && (
            <div className="order-presentation">
              <h3>Presentation</h3>
              <p>
                Representatives can select products (e.g., 4 hats) to present to
                the customer.
              </p>
            </div>
          )}
          {activeTab === "Estimate" && (
            <div className="order-estimate">
              <h3>Estimate</h3>
              <p>
                Complete the estimate details below. This form will eventually
                be used to generate a PDF invoice for customer approval.
              </p>
            </div>
          )}
          {activeTab === "Sales Order" && (
            <div className="order-sales">
              <h3>Sales Order</h3>
              <p>
                Complete the sales order details below. This form will
                eventually be used to generate a report for internal processing.
              </p>
            </div>
          )}
          {activeTab === "Shipping" && (
            <div className="order-shipping">
              <h3>Shipping</h3>
              <p>
                A table breakdown of all products in the order along with
                shipping info.
              </p>
              <div className="shipping-quote">
                <input
                  type="text"
                  placeholder="Enter shipping address for quick quote"
                  value={quoteAddress}
                  onChange={(e) => setQuoteAddress(e.target.value)}
                />
                <span className="map-marker" title="Map Marker">
                  📍
                </span>
                <button className="quote-button">Get Rate</button>
              </div>
            </div>
          )}
          {activeTab === "POs/Proofs" && (
            <div className="order-pos-proof">
              <h3>POs / Proofs</h3>
              <div className="tabs">
                <button onClick={() => setActivePOTab("Purchase Orders")}>
                  Purchase Orders
                </button>
                <button onClick={() => setActivePOTab("Proofs")}>Proofs</button>
              </div>
              {activePOTab === "pos-proofs" && <PurchaseOrderList />}
              {activePOTab === "Proofs" && (
                <div className="proofs-section">
                  <div className="proofs-header">
                    <button onClick={handleAddNewProof}>Upload Proof</button>
                    <label>
                      <input
                        type="checkbox"
                        checked={allProofsUploaded}
                        onChange={(e) => setAllProofsUploaded(e.target.checked)}
                      />
                      All proofs uploaded
                    </label>
                  </div>
                  {proofsList.map((proof, index) => (
                    <ProofSection
                      key={proof.id || index}
                      proof={proof}
                      onUpdateProof={(updatedProof) =>
                        handleUpdateProof(index, updatedProof)
                      }
                      onDeleteProof={() => handleDeleteProof(index)}
                    />
                  ))}
                  <button onClick={handleAddNewProof}>Add New Proof</button>
                </div>
              )}
            </div>
          )}
          {activeTab === "Invoice" && (
            <div className="order-invoice">
              <h3>Invoice</h3>
              <p>Final invoice details appear here once shipment lands.</p>
            </div>
          )}
          {activeTab === "Commissions" && (
            <div className="order-commissions">
              <h3>Commissions</h3>
              <p>Display commission details for the salesperson.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Image-based starting stage picker
const STAGE_CHOICES = [
  {
    key: "opportunity",
    label: "Opportunity",
    value: "Quote Requested",
    img: "/project-general-images/opportunity.png",
  },
  {
    key: "waiting",
    label: "Waiting",
    value: "Waiting",
    img: "/project-general-images/opportunity.png",
  },
  {
    key: "presentation",
    label: "Presentation",
    value: "Presentation Draft",
    img: "/project-general-images/presentation.png",
  },
  {
    key: "estimate",
    label: "Estimate",
    value: "Estimate Draft",
    img: "/project-general-images/estimate.png",
  },
  {
    key: "sales-order",
    label: "Sales Order",
    value: "Agreement Pending",
    img: "/project-general-images/sales-order.png",
  },
];

const StagePicker = ({ value, onChange, getWorkflowLabel }) => {
  return (
    <Box className="stage-tiles" role="radiogroup" aria-label="Starting Stage">
      {STAGE_CHOICES.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            type="button"
            key={opt.key}
            className={`stage-tile${selected ? " selected" : ""}`}
            onClick={() => onChange(opt.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(opt.value);
              }
            }}
            role="radio"
            aria-checked={selected}
          >
            <img src={opt.img} alt="" aria-hidden="true" />
            <span className="stage-label">
              {
                //getWorkflowLabel ? getWorkflowLabel("SO", opt.value) : opt.label
                getWorkflowLabel ? getWorkflowLabel("SO", opt.label) : opt.label
              }
            </span>
            {selected && <span className="stage-check">✓</span>}
          </button>
        );
      })}
    </Box>
  );
};

//
// ==============================
// Inline CreateOrderModal Component (Updated to include extra fields and custom CSS classes)
// ==============================
const CreateOrderModal = ({ open, onClose, onOrderCreated, customers }) => {
  let { instanceUniqueId } = useParams();
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [nextProjectNumber, setNextProjectNumber] = useState(null);
  const [clientContacts, setClientContacts] = useState([]);
  const [clientContactsLoading, setClientContactsLoading] = useState(false);
  const [clientContactsError, setClientContactsError] = useState("");
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);
  const contactRequestIdRef = useRef(0);

  const { authState } = useContext(AuthContext);
  const { getWorkflowLabel } = useWorkflowDisplaySettings(instanceUniqueId);

  // Remove "assigned_to" from initialValues since we handle it separately.
  const initialValues = {
    order_id: "100",
    attachedCustomers: [], // this will store the selected customer as an array (e.g. [1])
    clientContactId: "",
    email: "",
    projectName: "",
    phone: "",
    total: "",
    projectName: "",
    eventType: "",
    password: "", // keep if not present
    items: [], // default empty array; could be enhanced later
    siteURL: "https://",
    order_status: "Quote Requested", // default value; can be changed via select
  };

  useEffect(() => {
    if (!authState.id) return;
    axios
      .get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/basicinfo/${authState.id}`,
      )
      .then(({ data }) => {
        const rec = data.recommendedUsers || [];

        // build a full "me" entry, including role
        const me = {
          id: authState.id,
          role: authState.role,
          // you can also include name/email if you have them:
          first_name: authState.first_name,
          last_name: authState.last_name,
        };

        // if I'm not already in rec, prepend me
        const initial = rec.some((u) => u.id === authState.id)
          ? rec
          : [me, ...rec];

        setAssignedUsers(initial);
      })
      .catch((err) => {
        console.error("Error fetching my recommendedUsers:", err);
      });
  }, [authState]);

  useEffect(() => {
    if (!open || !instanceUniqueId) return;
    let active = true;

    const fetchNextNumber = async () => {
      try {
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
          { headers: { accessToken: localStorage.getItem("accessToken") } },
        );
        const instanceId = instanceRes?.data?.id ?? null;
        if (!instanceId || !active) return;

        const nextRes = await getNextProjectNumber(instanceId);
        if (active) {
          setNextProjectNumber(nextRes?.nextProjectNumber ?? null);
        }
      } catch (error) {
        console.error("Error fetching next project number:", error);
        if (active) setNextProjectNumber(null);
      }
    };

    fetchNextNumber();
    return () => {
      active = false;
    };
  }, [open, instanceUniqueId]);

  useEffect(() => {
    if (open) return;
    contactRequestIdRef.current += 1;
    setClientContacts([]);
    setClientContactsLoading(false);
    setClientContactsError("");
    setContactDialogOpen(false);
    setContactSaving(false);
  }, [open]);

  const loadClientContacts = useCallback(async (customerId) => {
    const requestId = ++contactRequestIdRef.current;
    setClientContacts([]);
    setClientContactsError("");

    if (!customerId) {
      setClientContactsLoading(false);
      return;
    }

    setClientContactsLoading(true);
    try {
      const contacts = await fetchClientContactOptions(customerId, getClientContacts);
      if (requestId !== contactRequestIdRef.current) return;
      setClientContacts(contacts);
    } catch (error) {
      if (requestId !== contactRequestIdRef.current) return;
      console.error("Error fetching client contacts:", error);
      setClientContacts([]);
      setClientContactsError("Unable to load client contacts. You can still create this project with N/A.");
    } finally {
      if (requestId === contactRequestIdRef.current) {
        setClientContactsLoading(false);
      }
    }
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    // Check for assigned users externally
    if (assignedUsers.length === 0) {
      toast.error("Assigned To is required");
      setSubmitting(false);
      return;
    }

    setSaving(true);

    axios
      .post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/create-order`,
        {
          data: {
            ...withOptionalClientContact(values),
            instanceUniqueId,
            assigned_to: assignedUsers,
          },
        },
        { headers: { accessToken: localStorage.getItem("accessToken") } },
      )
      .then((response) => {
        onOrderCreated(response.data);
        resetForm();
        onClose();
      })
      .catch((error) => {
        console.error("Error creating order", error);
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to create project. Please try again.";

        toast.error(message);
      })
      .finally(() => {
        setSaving(false);
        setSubmitting(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (
          saving &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        )
          return;
        onClose();
      }}
      disableEscapeKeyDown={saving}
      className="create-order-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="create-order-dialog-title">
        Create New Project
      </DialogTitle>
      <DialogContent className="create-order-dialog-content">
        <Box sx={{ mb: 2 }}>
          <TextField
            label="Next Project #"
            value={nextProjectNumber ?? "—"}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Box>
        <Formik
          key={open ? "new-project-open" : "new-project-closed"}
          initialValues={initialValues}
          validationSchema={createProjectValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => {
            const hasCustomer = values.attachedCustomers.length > 0;
            const selectedCustomerId = values.attachedCustomers[0] || null;
            const selectedCustomer = customers.find(
              (customer) => Number(customer?.id) === Number(selectedCustomerId),
            );
            const selectedBusinessName = getCustomerBusinessName(selectedCustomer);
            const handleCreateContact = async (payload) => {
              if (!selectedCustomerId) return;
              try {
                setContactSaving(true);
                const response = await createCustomerContact(selectedCustomerId, payload);
                const createdOption = normalizeCreatedClientContact(response?.data?.contact);
                if (!createdOption) throw new Error("Created contact did not include an id");
                setClientContacts((previous) => [
                  ...previous.filter(
                    (contact) => String(contact.contactId) !== String(createdOption.contactId),
                  ),
                  createdOption,
                ]);
                setFieldValue("clientContactId", createdOption.contactId);
                setContactDialogOpen(false);
                toast.success(`Contact added to ${selectedBusinessName}.`);
              } catch (error) {
                toast.error(error?.response?.data?.message || "Unable to create the customer contact.");
              } finally {
                setContactSaving(false);
              }
            };
            const handleCustomerChange = (e) => {
              const custId = e.target.value
                ? parseInt(e.target.value, 10)
                : null;
              const newArr = custId ? [custId] : [];
              setFieldValue("attachedCustomers", newArr);

              if (custId) {
                const cust = customers.find((c) => c.id === custId);
                if (cust) {
                  // auto-populate email, phone, URL
                  setFieldValue("email", cust.emailAddress || "");
                  setFieldValue("phone", cust.phoneNumber || "");
                  const firstSite =
                    Array.isArray(cust.websites) && cust.websites.length > 0
                      ? cust.websites[0]
                      : "";
                  setFieldValue("siteURL", firstSite); // feedback toast
                  //toast.success("Smart fields applied", { autoClose: 2000 });
                }
              }
            };
            return (
              <Form className="create-order-form">
                {/* Order ID */}
                <div
                  className="create-order-field-container"
                  style={{ display: "none" }}
                >
                  <Field
                    as={TextField}
                    label="Project ID"
                    name="order_id"
                    fullWidth
                    className="create-order-input"
                    disabled={true}
                    helperText={<ErrorMessage name="order_id" />}
                  />
                </div>

                {/* CUSTOMER SELECT (always visible) */}
                <div className="create-order-field-container">
                  <CustomerSearchSelectAsync
                    customers={customers}
                    value={values.attachedCustomers?.[0] ?? ""}
                    instanceUniqueId={instanceUniqueId}
                    onSelectCustomer={(cust) => {
                      if (cust) {
                        setFieldValue("email", cust.emailAddress || "");
                        setFieldValue("phone", cust.phoneNumber || "");
                        const firstSite =
                          Array.isArray(cust.websites) &&
                          cust.websites.length > 0
                            ? cust.websites[0]
                            : "";
                        setFieldValue("siteURL", firstSite || "https://");
                      } else {
                        setFieldValue("email", "");
                        setFieldValue("phone", "");
                        setFieldValue("siteURL", "https://");
                      }
                    }}
                    onChange={(custId) => {
                      const nextValues = getCustomerChangeValues(custId);
                      setFieldValue("attachedCustomers", nextValues.attachedCustomers);
                      setFieldValue("clientContactId", nextValues.clientContactId);
                      loadClientContacts(custId);
                    }}
                    error={
                      !!(
                        Array.isArray(values.attachedCustomers) &&
                        values.attachedCustomers.length === 0
                      )
                    }
                    helperText={
                      <ErrorMessage name="attachedCustomers">
                        {(msg) => <span className="error">{msg}</span>}
                      </ErrorMessage>
                    }
                  />
                  <ErrorMessage
                    name="attachedCustomers"
                    component="div"
                    className="error"
                  />
                </div>

                <ProjectCustomerEmailNotice
                  email={values.email}
                  customerId={selectedCustomerId}
                  instanceUniqueId={instanceUniqueId}
                />

                {/* Contact Email */}

                {hasCustomer && (
                  <>
                    <div
                      className="create-order-field-container"
                      style={{ display: "none" }}
                    >
                      <Field
                        as={TextField}
                        label="Contact Email"
                        name="email"
                        type="email"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="email" />}
                      />
                    </div>

                    {/* Contact Phone */}
                    <div
                      className="create-order-field-container"
                      style={{ display: "none" }}
                    >
                      <Field
                        as={TextField}
                        label="Contact Phone Number"
                        name="phone"
                        type="tel"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="phone" />}
                      />
                    </div>

                    {/* Site URL */}
                    {/*<div className="create-order-field-container">
                <Field
                  as={TextField}
                  label="Site URL"
                  name="siteURL"
                  type="url"
                  fullWidth
                  className="create-order-input"
                  helperText={<ErrorMessage name="siteURL" />}
                />
              </div>*/}

                    <div className="create-order-field-container">
                      <Field
                        as={TextField}
                        label="Project Name"
                        name="projectName"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="projectName" />}
                      />
                    </div>

                    <div className="create-order-field-container">
                      <FormControl fullWidth>
                        <InputLabel id="eventType-label">Event Type</InputLabel>
                        <Field
                          as={Select}
                          labelId="eventType-label"
                          label="Event Type"
                          name="eventType"
                          fullWidth
                          MenuProps={{
                            PaperProps: { style: { maxHeight: 360 } },
                          }}
                        >
                          {EVENT_TYPES.map((t) => (
                            <MenuItem key={t} value={t}>
                              {t}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                      <ErrorMessage
                        name="eventType"
                        component="div"
                        className="create-order-error"
                      />
                    </div>

                    {/* Order Status Select */}
                    <div className="create-order-field-container">
                      <label className="create-order-label">
                        Starting Stage
                      </label>
                      <StagePicker
                        value={values.order_status}
                        onChange={(val) => setFieldValue("order_status", val)}
                        getWorkflowLabel={getWorkflowLabel}
                      />
                      <ErrorMessage
                        name="order_status"
                        component="div"
                        className="create-order-error"
                      />
                    </div>

                    <Accordion sx={{ mt: 1 }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={600}>Assign users</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="create-order-field-container">
                          <OrderUserAssignment
                            orderId=""
                            initialAssignedUsers={assignedUsers}
                            onChangeAssignedUsers={(newAssignedUsers) =>
                              setAssignedUsers(newAssignedUsers)
                            }
                          />
                        </div>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion sx={{ mt: 1 }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={600}>Client Contact</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Button
                          type="button"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={() => setContactDialogOpen(true)}
                          sx={{ mb: 1.5 }}
                        >
                          Add contact to {selectedBusinessName}
                        </Button>
                        <FormControl fullWidth disabled={clientContactsLoading}>
                          <InputLabel id="new-project-client-contact-label">Client Contact</InputLabel>
                          <Select
                            labelId="new-project-client-contact-label"
                            id="new-project-client-contact"
                            name="clientContactId"
                            label="Client Contact"
                            value={values.clientContactId || ""}
                            onChange={(event) => setFieldValue("clientContactId", event.target.value)}
                            endAdornment={clientContactsLoading ? <CircularProgress size={18} sx={{ mr: 4 }} /> : null}
                          >
                            <MenuItem value="">N/A</MenuItem>
                            {clientContacts.map((contact) => (
                              <MenuItem key={contact.contactId} value={contact.contactId}>
                                {contact.displayLabel}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {!clientContactsLoading && !clientContactsError && clientContacts.length === 0 ? (
                          <FormHelperText>No client contacts available for this customer.</FormHelperText>
                        ) : null}
                        {clientContactsError ? (
                          <Alert severity="warning" sx={{ mt: 1 }}>{clientContactsError}</Alert>
                        ) : null}
                        <CustomerContactDialog
                          open={contactDialogOpen}
                          loading={contactSaving}
                          onClose={() => setContactDialogOpen(false)}
                          onSubmit={handleCreateContact}
                          targetLabel={selectedBusinessName}
                        />
                      </AccordionDetails>
                    </Accordion>

                    {/* Hidden Items Field */}
                    <Field
                      type="hidden"
                      name="items"
                      value={JSON.stringify(values.items)}
                    />

                    <DialogActions className="create-order-dialog-actions">
                      <Button
                        onClick={onClose}
                        color="secondary"
                        className="create-order-cancel-button"
                        disabled={saving}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        disabled={saving || isSubmitting} // ← double lock (Formik + our flag)
                        className="create-order-submit-button"
                      >
                        {saving || isSubmitting ? <ButtonLoader /> : "Create Project"}
                      </Button>
                    </DialogActions>
                  </>
                )}
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

//
// ==============================
// ProofSection Component
// ==============================
const ProofSection = ({ proof, onUpdateProof, onDeleteProof }) => {
  const [localProof, setLocalProof] = useState(proof);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    const updated = { ...localProof, status: newStatus };
    setLocalProof(updated);
    onUpdateProof(updated);
  };

  const handleCommentChange = (e) => {
    const newComment = e.target.value;
    const updated = { ...localProof, comment: newComment };
    setLocalProof(updated);
    onUpdateProof(updated);
  };

  return (
    <div className="proof-section">
      <div className="proof-left">
        <img
          src={localProof.image || "https://placehold.co/100x100"}
          alt="Proof"
        />
      </div>
      <div className="proof-middle">
        <p className="proof-file-name">
          {localProof.fileName || "No file selected"}
        </p>
        <select
          className="proof-status-select"
          value={localProof.status || ""}
          onChange={handleStatusChange}
        >
          <option value="Proof received">Proof received</option>
          <option value="Pending approval">Pending approval</option>
          <option value="Change requested">Change requested</option>
          <option value="Client approved">Client approved</option>
          <option value="Proofing complete">Proofing complete</option>
        </select>
        <button
          className="proof-download-button"
          onClick={() => alert("Download proof functionality")}
        >
          Download
        </button>
      </div>
      <div className="proof-right">
        <textarea
          className="proof-comment-textarea"
          placeholder="Comment on this proof..."
          value={localProof.comment || ""}
          onChange={handleCommentChange}
        />
        {localProof.comments && localProof.comments.length > 0 && (
          <div className="proof-comments">
            {localProof.comments.map((c, idx) => (
              <div key={idx} className="proof-comment">
                <strong>{c.name}</strong> ({c.timeAgo}): {c.text}
              </div>
            ))}
          </div>
        )}
      </div>
      <button className="proof-delete-button" onClick={onDeleteProof}>
        Delete Proof
      </button>
    </div>
  );
};

export { InstanceOrders, CustomerSearchSelect };

function normalize(s = "") {
  return s
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

function CustomerSearchSelect({
  customers = [],
  value,
  onChange,
  label = "Customer Account",
  error = false,
  helperText = "",
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = normalize(query);
    if (!q) return customers;
    return customers.filter((c) => {
      const name =
        c.businessName || `${c.firstName ?? ""} ${c.lastName ?? ""}`.trim();
      const email = c.emailAddress ?? "";
      const phone = c.phoneNumber ?? "";
      const hay = `${name} ${email} ${phone}`;
      return normalize(hay).includes(q);
    });
  }, [customers, query]);

  const handleSelect = (e) => {
    const val = e.target.value;
    onChange(val ? parseInt(val, 10) : null);
  };

  return (
    <FormControl
      className="search-by-customer-container"
      fullWidth
      error={!!error}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value ?? ""}
        onChange={handleSelect}
        className="search-by-customer-select"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setQuery("");
        }}
        MenuProps={{
          disableAutoFocusItem: true,
          keepMounted: true,
          PaperProps: {
            style: {
              maxHeight: 360,
              width: 480,
              marginTop: "30px",
            },
          },
        }}
      >
        {/* Styled search box container */}
        <Box
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          sx={{
            background: "#e0ecf9",
            px: "15px",
            py: "10px",
            position: "sticky",
            top: 0,
            zIndex: 999,
            paddingBottom: "10px",
          }}
        >
          <TextField
            autoFocus
            size="small"
            placeholder="Search by name, email, or phone…"
            fullWidth
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            variant="outlined"
            sx={{ background: "#FFF" }}
          />
        </Box>

        {/* No divider anymore */}

        {filtered.length === 0 ? (
          <MenuItem disabled>No matches</MenuItem>
        ) : (
          filtered.slice(0, 300).map((c) => {
            const name =
              c.businessName ||
              `${c.firstName ?? ""} ${c.lastName ?? ""}`.trim() ||
              "Unnamed";
            return (
              <MenuItem key={c.id} value={c.id}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body2">{name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {(c.emailAddress || "").trim()}
                    {c.phoneNumber ? ` • ${c.phoneNumber}` : ""}
                  </Typography>
                </Box>
              </MenuItem>
            );
          })
        )}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
